/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Table_ActionsInputs */

const en_speaker_manager_table_actions = /** @type {(inputs: Speaker_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const fr_speaker_manager_table_actions = /** @type {(inputs: Speaker_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const de_speaker_manager_table_actions = /** @type {(inputs: Speaker_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen`)
};

const it_speaker_manager_table_actions = /** @type {(inputs: Speaker_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni`)
};

const ru_speaker_manager_table_actions = /** @type {(inputs: Speaker_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действия`)
};

const es_speaker_manager_table_actions = /** @type {(inputs: Speaker_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comportamiento`)
};

const zh_cn2_speaker_manager_table_actions = /** @type {(inputs: Speaker_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行动`)
};

const ja_speaker_manager_table_actions = /** @type {(inputs: Speaker_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクション`)
};

const hi_speaker_manager_table_actions = /** @type {(inputs: Speaker_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्रवाई`)
};

const pt_pt2_speaker_manager_table_actions = /** @type {(inputs: Speaker_Manager_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Speaker_Manager_Table_ActionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_table_actions = /** @type {((inputs?: Speaker_Manager_Table_ActionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Table_ActionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_table_actions(inputs)
	if (locale === "de") return de_speaker_manager_table_actions(inputs)
	if (locale === "it") return it_speaker_manager_table_actions(inputs)
	if (locale === "ru") return ru_speaker_manager_table_actions(inputs)
	if (locale === "es") return es_speaker_manager_table_actions(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_table_actions(inputs)
	if (locale === "ja") return ja_speaker_manager_table_actions(inputs)
	if (locale === "hi") return hi_speaker_manager_table_actions(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_table_actions(inputs)
	return en_speaker_manager_table_actions(inputs)
});